import Auth from '.'

export default function authReducer (state, action) {
  const initialState = {
    status: Auth.LOGGED_OUT,
    userDetails: {},
  }

  switch (action.type) {
    case 'SUCCESS_LOGIN':
    case 'START_LOGIN':
    case 'SUCCESS_LOGOUT':
    case 'LOGIN_FAILED':
    case 'FIRST_LOGIN':
      return {
        status: action.status,
        userDetails: action.userDetails,
        cognitoUser: action.cognitoUser,
      }
    case 'UPDATE_DETAILS':
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          ...action.userDetails,
        },
      }
    case 'SET_ROLE':
      return {
        ...state,
        role: action.role,
      }
    case 'persist/REHYDRATE':
      const persistedState = action.payload.auth || initialState
      return {
        ...persistedState,
        // Only two states that can be persisted are LOGGED_IN or LOGGED_OUT
        status: persistedState.status === Auth.LOGGED_IN ? Auth.LOGGED_IN : Auth.LOGGED_OUT,
      }
    default:
      return state || initialState
  }
}



// WEBPACK FOOTER //
// ./src/store/Auth/reducer.js